import Event from '../../entities/Event';
import EventsReporter from '../EventsReporter';
class NewsFeedEventReporter extends EventsReporter {
    sendPostReaction({ type, id, format, title, publishedDate, authorName, viewDuration }) {
        const event = new Event('For You - Feed - Post - Reacted', {
            type,
            id,
            format,
            title,
            publishedDate,
            authorName,
            viewDuration
        });
        this._insightsService.sendEvent(event);
    }
    loaded({ postQty: postQuantity, newestPostDate, oldestPostDate }) {
        const event = new Event('For You - Feed - Feed - Loaded', {
            postQty: postQuantity,
            newestPostDate,
            oldestPostDate
        });
        this._insightsService.sendEvent(event);
    }
    failedToLoad({ code, message }) {
        const event = new Event('For You - Feed - Feed - Error', { code, message });
        this._insightsService.sendEvent(event);
    }
    reachedToEnd({ postQty: postQuantity, newestPostDate, oldestPostDate }) {
        const event = new Event('For You - Feed - End - Reached', {
            postQty: postQuantity,
            newestPostDate,
            oldestPostDate
        });
        this._insightsService.sendEvent(event);
    }
    sendPostAsSeen({ id, format, title, publishedDate, authorName, viewDuration }) {
        const event = new Event('For You - Feed - Post - Viewed', {
            id,
            format,
            title,
            publishedDate,
            authorName,
            viewDuration
        });
        this._insightsService.sendEvent(event);
    }
}
export default NewsFeedEventReporter;
